<template>
  <div :class="navigationbar ? 'category_active' : 'category'">
    <div v-show="categoryBar == 1" class="category_box_1">
      <div v-if="GameList.length > 0" class="game_box">
        <div class="game" v-for="(item, i) in GameList" :key="i">
          <div class="list" @click="bar(2, i)">
            <!-- <div class="list_img">{{ item.gameList[0].imageSrc }}</div> -->
            <img class="list_img" :src="item.gameList[0].imageSrc" alt="" />
            <div class="list_title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="categoryBar == 2" class="category_box">
      <div class="close_box">
        <div class="close" @click="ret">
          <img class="close_img" :src="require('@/img/back.png')" alt />
          <div class="close_title">{{ GameList[listIndex].title }}</div>
        </div>
      </div>

      <div :class="navigationbar ? 'DAILY_box2_active' : 'DAILY_box2'">
        <div class="DAILY_box game_main" @touchmove="Playtouchmove">
          <div
            class="DAILY_list"
            v-for="(item, index) in GameList[listIndex].gameList"
            :key="index"
            @click="onPlay(item)"
            @touchstart="Playtouchstart($event, listIndex, index)"
            @touchend="Playtouchend($event, listIndex, index)"
          >
            <img class="DAILY_game imgs" :src="item.imageSrc" alt="" />
            <div class="DAILY_title">{{ item.name }}</div>
            <div
              class="DAILY_btn"
              :class="
                3 == bg_i && bg_index == index && bg_i != -1 ? 'btn-active' : ''
              "
            >
              {{ $t("index.open") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hint" v-if="hintloading">
      <div class="hint_loading_box">
        <img class="hint_loading" src="@/img/gif2.gif" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import configs from "@/config/config.js";
export default {
  directives: {
    infiniteScroll,
  },
  data() {
    return {
      boxshow: true,
      categoryBar: 1,
      isAndroid: true,
      isiOS: false,
      listIndex: 0,
      bg_i: -1,
      bg_index: -1,
      hintloading: false,
      navigationbar: false,
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    ...mapState("game", ["actionlist"]),
    ...mapState("game", ["GameList"]),
  },
  watch: {
    searchKey(n) {
      this.$nextTick(function () {
        this.onSearch();
      });
    },
  },

  created() {
    this.getTheme = configs.getTheme();

    var u = navigator.userAgent;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    const navigationbar =
      configs.GetQueryString("navigationbar") ||
      this.$route.query.navigationbar;
    if (navigationbar && navigationbar == "true") {
      this.navigationbar = true;
    }
  },
  destroyed: function () {
    this.clearViews();
  },
  mounted() {
    var self = this;
    if (self.isAndroid) {
      window.onbeforeunload = function (e) {
        var e = window.event || e;
        self.hintloading = false;
      };
    } else if (self.isiOS) {
      window.addEventListener("pagehide", function () {
        self.hintloading = false;
      });
    }
  },
  methods: {
    ...mapActions("game", [
      "searchGame",
      "changeRecentPlayList",
      "gamePlay",
      "UserFinishTask",
    ]),
    ...mapActions("user", ["UserFinishTask"]),

    clearViews() {
      var self = this;
      self.hintloading = false;
      clearTimeout(self.clearpaly);
    },
    Playtouchstart(e, i, index) {
      this.bg_i = i;
      this.bg_index = index;

      this.bg_scrollTop = document.querySelector(".game_main").scrollTop;
    },
    Playtouchend(e, i, index) {
      this.bg_i = -1;
      this.bg_index = -1;
    },
    Playtouchmove(e, i, index) {
      var top = document.querySelector(".game_main").scrollTop;
      if (this.bg_scrollTop - top > 8 || top - this.bg_scrollTop > 8) {
        this.bg_i = -1;
        this.bg_index = -1;
      }
    },
    bar(index, i) {
      if (localStorage.getItem("txn_id")) {
        this.categoryBar = index;
        this.listIndex = i;
      } else {
        if (index == 2) {
          this.openAppLogin({
            $axios: this.$axios,
            status: true,
          });
        }
      }
    },
    // 后退
    ret() {
      this.categoryBar = 1;
    },
    // 点击去玩游戏
    async onPlay(item) {
      var self = this;
      // 点击去玩就添加数据到缓存
      var time = new Date().getTime();
      localStorage.setItem("ShareGame", JSON.stringify(item));
      localStorage.setItem("Sharetime", JSON.stringify(time));

      this.hintloading = true;
      this.clearpaly = setTimeout(function () {
        self.hintloading = false;
      }, 600000);

      this.changeRecentPlayList({
        $axios: this.$axios,
        recentPlay: item,
        userId: this.userInfo.id,
      });
      // 新版统计
      window.dataKule.push("track", "game", "play-btn", {
        id: item.gameId,
      });
      const res = await this.gamePlay({
        $axios: this.$axios,
        $router: this.$router,
        url: item.playUrl,gameId: item.gameId,
        ImageSrc: item.imageSrc,
        $root: this.$root,
      });

      this.hintloading = res;

      // 只要去玩就发送签到
      // await self.UserFinishTask({
      //   $axios: self.$axios,
      //   // self.actionlist.actionId
      //   actionId: 1,
      //   taskId: "task02",
      //   objectId: item.gameId
      // });
    },
  },
};
</script>

<style scoped="scoped">
@media screen and (min-width: 1000px) {
  .DAILY_box {
    max-width: 800px !important;
    /* margin: 0 auto !important; */
  }
}

.category {
  padding-top: 1.32rem;
  background: #f7f8fc;
  height: 100%;
}
.category_active {
  padding-top: 2.82rem;
  background: #f7f8fc;
  height: 100%;
}

.category_box {
  padding: 0 0.4rem;
}
.category_box_1 {
  padding: 0 0.4rem;
  height: 100%;
}

.list {
  background-color: #ffffff;
  box-shadow: 0 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.03);
  border-radius: 0.3rem;
  /* width: 10rem; */
  height: 1.5rem;
  line-height: 1.5rem;
  display: flex;
}

.list_img {
  padding-left: 0.37rem;
  padding-top: 0.37rem;
  width: 0.75rem;
  height: 0.75rem;
}

.list_title {
  padding-left: 0.3rem;
  height: 0.32rem;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.42rem;
  font-weight: normal;
  font-stretch: normal;
  color: #1b1b1b;
}

.game {
  padding-top: 0.2rem;
}
.game_box {
  width: 93%;
  position: absolute;
}
.close {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 0.2rem;
}

.close_img {
  width: 0.33rem;
  height: 0.54rem;
}

.close_title {
  display: block;
  margin: 0 auto;
  font-size: 0.42rem;
  font-weight: normal;
  font-stretch: normal;
  color: #1b1b1b;
}

.DAILY_box2 {
  padding-right: 0.2rem;
  position: absolute;
  height: calc(100% - 2.1rem);
  width: 98%;
  overflow: auto;
}
.DAILY_box2_active {
  padding-right: 0.2rem;
  position: absolute;
  height: calc(100% - 3.6rem);
  width: 98%;
  overflow: auto;
}

.DAILY_box {
  margin-top: 0.49rem;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.DAILY_list {
  width: calc(100% / 4);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.59rem;
}

.DAILY_game {
  width: 2rem;
  height: 2rem;
  border-radius: 0.3rem;
  object-fit: cover;
}

.DAILY_title {
  margin-top: 0.2rem;
  text-align: center;
  width: 2.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--indexListColor);
  font-size: 0.36rem;
  font-weight: bold;
}

.DAILY_btn {
  margin-top: 0.35rem;
  width: 1.81rem;
  height: 0.76rem;
  background-color: var(--rankBackgroundBtn);
  border-radius: 0.37rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.36rem;
  color: var(--rankColorBtn);
}

.hint {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.hint_loading_box {
  width: 3rem;
  height: 3rem;
  /* background-color: rgba(0, 0, 0, 0.8); */
  /* border-radius: 0.4rem; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.hint_loading {
  width: 3rem;
  height: 3rem;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/category.vue